<template>
    <div class="main">
        <div class="row mt-5 main-card-wrap">
            <div class="col">
                <div class="card" style="width: 21rem;">
                    <button type="button" class="btn-survey-enter" @click="popup('https://slphouse-5.readdy.co')">
                        <figure>
                            <img src="../assets/images/slphouse_main11.png" class="card-img-top" alt="">
                        </figure>
                        <div class="card-body">
                            <p class="card-text">치료 프로그램 스케줄링 시스템</p>
                        </div>
                    </button>
                </div>
            </div>
            <div class="col">
                <div class="card" style="width: 21rem;">
                    <button type="button" class="btn-survey-enter" @click="popup('https://slphouse-6.readdy.co/login')">
                        <figure>
                            <img src="../assets/images/slphouse_main13.png" class="card-img-top" alt="">
                        </figure>
                        <div class="card-body">
                            <p class="card-text">다양한 개념을 익히고, 상황의 원인과 결과를 이해하며, 해결 방법을 말로 표현하는 6단계 언어문제해결 중재프로그램</p>
                        </div>
                    </button>
                </div>
            </div>
            <div class="col">
                <div class="card" style="width: 21rem;">
                    <button type="button" class="btn-survey-enter" @click="popup('https://slphouse-1.readdy.co')">
                        <figure>
                            <img src="../assets/images/slphouse_main7.png" class="card-img-top" alt="">
                        </figure>
                        <div class="card-body">
                            <p class="card-text">언어, 사회성, 감정 이해, 문제해결을 즐겁게 배울 수 있는 보드게임</p>
                        </div>
                    </button>
                </div>
            </div>
            <div class="col">
                <div class="card" style="width: 21rem;">
                    <button type="button" class="btn-survey-enter" @click="popup('https://slphouse-2.readdy.co')">
                        <figure>
                            <img src="../assets/images/slphouse_main8.png" class="card-img-top" alt="">
                        </figure>
                        <div class="card-body">
                            <p class="card-text">사회적 의사소통 상황에 따른 대화기술증진 프로그램</p>
                        </div>
                    </button>
                </div>
            </div>
            <div class="col">
                <div class="card" style="width: 21rem;">
                    <button type="button" class="btn-survey-enter" @click="popup('https://slphouse-3.readdy.co')">
                        <figure>
                            <img src="../assets/images/slphouse_main9.png" class="card-img-top" alt="">
                        </figure>
                        <div class="card-body">
                            <p class="card-text">이야기 카드로 키우는 언어와 순서,추론 증진 프로그램</p>
                        </div>
                    </button>
                </div>
            </div>
            <div class="col">
                <div class="card" style="width: 21rem;">
                    <button type="button" class="btn-survey-enter" @click="popup('https://slphouse-4.readdy.co')">
                        <figure>
                            <img src="../assets/images/slphouse_main10.png" class="card-img-top" alt="">
                        </figure>
                        <div class="card-body">
                            <p class="card-text">조음음운치료의 모든 것!</p>
                        </div>
                    </button>
                </div>
            </div>
            <div class="col">
                <div class="card" style="width: 21rem;">
                    <button type="button" class="btn-survey-enter" data-bs-toggle="modal" data-bs-target="#staticBackdrop" @click="codeType('icb')">
                        <figure>
                            <img src="../assets/images/slphouse_main1.png" class="card-img-top" alt="">
                        </figure>
                        <div class="card-body">
                            <p class="card-text">아동의 의사소통 기능 및 수단을 단계적으로 확인할 수 있는 설문지(ICB)</p>
                        </div>
                    </button>
                </div>
            </div>
            <div class="col">
                <div class="card" style="width: 21rem;">
                    <button type="button" class="btn-survey-enter" data-bs-toggle="modal" data-bs-target="#staticBackdrop" @click="codeType('conve')">
                        <figure>
                            <img src="../assets/images/slphouse_main2.png" class="card-img-top" alt="">
                        </figure>
                        <div class="card-body">
                            <p class="card-text">아동의 대화기술 능력을 체계적으로 확인할 수 있는 설문지</p>
                        </div>
                    </button>
                </div>
            </div>
            <div class="col">
                <div class="card" style="width: 21rem;">
                    <button type="button" class="btn-survey-enter" data-bs-toggle="modal" data-bs-target="#staticBackdrop" @click="codeType('gen')">
                        <figure>
                            <img src="../assets/images/slphouse_main3.png" class="card-img-top" alt="">
                        </figure>
                        <div class="card-body">
                            <p class="card-text">아동의 대화기술을 일반화할 수 있는 프로그램</p>
                        </div>
                    </button>
                </div>
            </div>
            <div class="col">
                <div class="card" style="width: 21rem;">
                    <button class="btn-survey-enter" data-bs-toggle="modal" data-bs-target="#staticBackdrop" @click="codeType('talk')">
                        <figure>
                            <img src="../assets/images/slphouse_main4.png" class="card-img-top" alt="">
                        </figure>
                        <div class="card-body">
                            <p class="card-text">WEB기반 어휘학습 프로그램</p>
                        </div>
                    </button>
                </div>
            </div>
            <div class="col">
                <div class="card" style="width: 21rem;">
                    <button class="btn-survey-enter" data-bs-toggle="modal" data-bs-target="#staticBackdrop" @click="codeType('episode')">
                        <figure>
                            <img src="../assets/images/slphouse_main5.png" class="card-img-top" alt="">
                        </figure>
                        <div class="card-body">
                            <p class="card-text">우리 아이 화용언어기술을 일반화 할 수 있는 프로그램​</p>
                        </div>
                    </button>
                </div>
            </div>
            <div class="col">
                <div class="card" style="width: 21rem;">
                    <button class="btn-survey-enter" data-bs-toggle="modal" data-bs-target="#staticBackdrop" @click="codeType('training')">
                        <figure>
                            <img src="../assets/images/slphouse_main6.png" class="card-img-top" alt="">
                        </figure>
                        <div class="card-body">
                            <p class="card-text">안면 및 구강 운동 훈련을 위한 활동 프로그램</p>
                        </div>
                    </button>
                </div>
            </div>
            <div class="col">
                <div class="card" style="width: 21rem;">
                    <button class="btn-survey-enter" data-bs-toggle="modal" data-bs-target="#staticBackdrop" disabled>
                        <figure>
                            <img src="../assets/images/slphouse_main14.png" class="card-img-top" alt="">
                        </figure>
                        <div class="card-body">
                            <p class="card-text"></p>
                        </div>
                    </button>
                </div>
            </div>
            
            <!-- <div class="col">
                <div class="card" style="width: 21rem;">
                    <button type="button" class="btn-survey-enter" @click="rinkTo()">
                        <figure>
                            <img src="../assets/images/slphouse_main3.png" class="card-img-top" alt="">
                        </figure>
                        <div class="card-body">
                            <p class="card-text">test</p>
                        </div>
                    </button>
                </div>
            </div> -->
        </div>
    </div>

    <!-- Modal -->
    <div class="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="staticBackdropLabel">Please enter the code.</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body" v-if="surveyType">
                    <form>
                        <div class="row g-3 align-items-center">
                            <div class="col-auto">
                                <label for="survey-code" class="col-form-label">{{ surveyType.toUpperCase() }} CODE</label>
                            </div>
                            <div class="col-auto position-relative">
                                <input v-if="surveyType === 'icb'" type="password" maxlength="9" id="survey-code" class="form-control" aria-describedby="passwordHelpInline" @input="codeInput($event.target.value)" @keydown.enter.prevent="codeValidation" autocomplete="on" required>
                                <input v-if="surveyType === 'conve'" type="password" maxlength="6" id="survey-code" class="form-control" aria-describedby="passwordHelpInline" @input="codeInput($event.target.value)" @keydown.enter.prevent="codeValidation" autocomplete="on" required>
                                <input v-if="surveyType === 'gen'" type="password" maxlength="12" id="survey-code" class="form-control" aria-describedby="passwordHelpInline" @input="codeInput($event.target.value)" @keydown.enter.prevent="codeValidation" autocomplete="on" required>
                                <input v-if="surveyType === 'talk'" type="password" id="survey-code" class="form-control" aria-describedby="passwordHelpInline" @input="codeInput($event.target.value)" @keydown.enter.prevent="codeValidation" autocomplete="on" required>
                                <input v-if="surveyType === 'episode'" type="password" id="survey-code" class="form-control" aria-describedby="passwordHelpInline" @input="codeInput($event.target.value)" @keydown.enter.prevent="codeValidation" autocomplete="on" required>
                                <input v-if="surveyType === 'training'" type="password" id="survey-code" class="form-control" aria-describedby="passwordHelpInline" @input="codeInput($event.target.value)" @keydown.enter.prevent="codeValidation" autocomplete="on" required>
                                <div class="invalid-tooltip" :class="{'on': !validCheck}">
                                    Please provide a {{ surveyType.toUpperCase() }} Code.
                                </div>
                            </div>
                            <div class="col-auto">
                                <span id="passwordHelpInline" class="form-text" v-if="surveyType === 'icb'">
                                    Must be 9 characters long.
                                </span>
                                <span id="passwordHelpInline" class="form-text" v-if="surveyType === 'conve'">
                                    Must be 6 characters long.
                                </span>
                                <span id="passwordHelpInline" class="form-text" v-if="surveyType === 'gen'">
                                    Must be 'SLP-' 4 characters long.
                                </span>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                    <button type="button" class="btn btn-primary" @click="codeValidation">Sign In</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState, mapMutations } from 'vuex';

    export default {
        name: 'Main',
        data() {
            return {
                type: null
            }
        },
        computed: {
            ...mapState(['surveyType', 'icbCode', 'validCheck', 'icb', 'conve']),
        },
        methods: {
            ...mapMutations(['codeType', 'codeInput', 'codeValidation']),
            popup: (url) => {
                console.log('test')
                window.open(url, "_blank", {
                    width:  window.innerWidth,
                    height: window.innerHeight
                })
            }
        },
       
    }
</script>

<style scoped>
    .main {
        width: 90vw;
        margin: 0 auto;
    }

    .main-card-wrap {
        display: flex;
        gap: 20px;
        padding-bottom: 40px;
    }

    .col .card {
        min-height: 520px;
        margin: auto;
    }

    .col .card-img-top {
        width: 88%;
    }

    .col .card .btn-survey-enter {
        min-height: 520px;
        height: 100%;
        padding: 0;
        background-color: transparent;
        border: none;
        text-decoration: none;
        color: #000;
    }

    .col .card .btn-survey-enter figure {
        height: 380px;    
    }

    .title-type .card .btn-survey-enter figure {
        height: 300px;
    }

    .title-type .card .btn-survey-enter .card-body strong {
        display: block;
        margin-top: -50px;
        margin-bottom: 10px;
    }

    .on {
        display: block;
    }

    .card-body {
        height: 6.5rem;
    }

    .btn-survey-enter {
        transition: box-shadow 0.5s;
    }

    .btn-survey-enter:hover {
        box-shadow: 0 2px 15px rgba(0, 0, 0, 0.1);
    }

    @media (max-width: 1024px) {
        .row .col {
            padding: calc(var(--bs-gutter-x) *.5);
        }
    }
</style>